import { render, staticRenderFns } from "./index_contact.vue?vue&type=template&id=0a8fce52&scoped=true"
import script from "./index_contact.vue?vue&type=script&lang=js"
export * from "./index_contact.vue?vue&type=script&lang=js"
import style0 from "./index_contact.vue?vue&type=style&index=0&id=0a8fce52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8fce52",
  null
  
)

export default component.exports